// AUTO-GENERATED from CHANGELOG.md by scripts/build-changelog.js — do not edit.
// Regenerated on `npm start` / `npm run build` (prestart / prebuild hooks).

export interface ChangelogGroup {
  title: string;
  items: string[];
}

export interface ChangelogVersion {
  /** "Unreleased" or a semver string like "1.2.0". */
  version: string;
  /** ISO-ish date string, or null for the Unreleased section. */
  date: string | null;
  groups: ChangelogGroup[];
}

export const changelog: ChangelogVersion[] = [
  {
    "version": "Unreleased",
    "date": null,
    "groups": []
  },
  {
    "version": "1.1.2",
    "date": "2026-10-27",
    "groups": [
      {
        "title": "Events",
        "items": [
          "Removal running time now updates when the dates change."
        ]
      },
      {
        "title": "Tables & dashboard",
        "items": [
          "Lists can now be exported as Excel files, not just CSV.",
          "World map now opens centred on your own continent.",
          "World map can now be opened full screen."
        ]
      }
    ]
  },
  {
    "version": "1.1.1",
    "date": "2026-10-23",
    "groups": [
      {
        "title": "Installed Base",
        "items": [
          "Favorites are now listed first in the installed base tree"
        ]
      },
      {
        "title": "Tables & dashboard",
        "items": [
          "The asset locations map on the dashboard now opens filled to the edges and can no longer be zoomed or dragged beyond the world",
          "Overlapping clusters on the asset locations map are combined, larger clusters are drawn on top of smaller ones and large counts are abbreviated (e.g. 28k)"
        ]
      }
    ]
  },
  {
    "version": "1.1.0",
    "date": "2026-10-21",
    "groups": [
      {
        "title": "General",
        "items": [
          "Global Release"
        ]
      }
    ]
  },
  {
    "version": "1.0.5",
    "date": "2026-10-21",
    "groups": [
      {
        "title": "Assets",
        "items": [
          "IoT connections can now be set up for customers in all regions, no longer only in Germany and the United Kingdom",
          "A vacuum check now requires the completed vacuum check form to be uploaded; the upload step links the form template to download and fill in",
          "Busch employees now see the customer's contact persons on asset and system dashboards"
        ]
      },
      {
        "title": "Events",
        "items": [
          "Event details are easier to read and browse"
        ]
      },
      {
        "title": "Tables & dashboard",
        "items": [
          "Cards on asset and system dashboards now share one consistent look",
          "Table columns can now be reordered; CSV exports keep that order",
          "The systems list can now be exported as CSV"
        ]
      },
      {
        "title": "Installed Base",
        "items": [
          "Reopening a selected entry in long lists is now much faster",
          "Selecting a node in the node picker no longer moves it to the top",
          "After saving an IoT system, you are taken back to the system dashboard, and editing it again works without reloading the page"
        ]
      },
      {
        "title": "Service reminders & notifications",
        "items": [
          "Users with access to many companies can save IoT report subscriptions again"
        ]
      }
    ]
  },
  {
    "version": "1.0.4",
    "date": "2026-10-15",
    "groups": [
      {
        "title": "General",
        "items": [
          "Security updates for third-party components; the map on the dashboard now runs on the current MapLibre version",
          "ARGOS users now reach their own bug report and feature request forms",
          "French, Korean and Chinese are now supported",
          "Changing the language in your profile now takes effect immediately, without reloading the page manually",
          "Reviewed and consistent English and German texts throughout the app, and texts that were previously only shown in English are now translated"
        ]
      },
      {
        "title": "Assets",
        "items": [
          "The asset list can now show which parameter went out of range, the recorded value and the lower and upper thresholds; these columns open automatically from the \"Sensor Value out of Range\" dashboard widget",
          "Sub-assets can now be created directly from an asset's dashboard, via the actions menu or the sub-assets widget; the widget's entries open the sub-asset, and \"View all\" shows them in the installed base",
          "The asset list loads faster and can be sorted by column",
          "The asset list can be filtered to assets in your starred installed base elements",
          "The asset dashboard shows the IoT status faster",
          "IoT-connected TYR pumps record whether they have an acoustic enclosure; the asset specifications show it"
        ]
      },
      {
        "title": "Installed Base",
        "items": [
          "Assets and systems in the tree open their detail page directly; editing opens the details panel"
        ]
      },
      {
        "title": "Service reminders & notifications",
        "items": [
          "Notification subscriptions can now alert you when maintenance or remanufacturing becomes due, either from the first warning or only once it is overdue, optionally limited to one kind of maintenance (IBM-912)",
          "The notification preferences point out when your email address is still unverified, since no notifications are delivered until it is",
          "Adding a notification subscription now happens in two steps (choose the installed base node or region, then the settings), and the subscription dialogs got the same header icon and button layout as the other dialogs"
        ]
      }
    ]
  },
  {
    "version": "1.0.3",
    "date": "2026-09-16",
    "groups": [
      {
        "title": "Installed Base",
        "items": [
          "Systems can now be deleted from the system dashboard, not just from the installed base",
          "Deleting a system is no longer blocked when it has an IoT connection; the dialog says upfront that the connection will be detached",
          "Assets, systems and installed base nodes can now have their own image",
          "In the node detail view, Save and Cancel now only appear once something in the form has been changed; Cancel discards the changes",
          "Favorite nodes are marked with a star in the installed base tree",
          "Nodes get a Contact tab showing their contact persons and the responsible service center; the service center also appears on the dashboard"
        ]
      },
      {
        "title": "Assets",
        "items": [
          "Long event messages no longer push the asset dashboard layout out of shape; they are shortened with an ellipsis and shown in full on hover"
        ]
      },
      {
        "title": "Customer Management",
        "items": [
          "Contact persons can now be managed per customer in the CRM",
          "Service centers and their departments can be managed in the CRM and assigned to customers and regions"
        ]
      }
    ]
  },
  {
    "version": "1.0.2",
    "date": "2026-09-02",
    "groups": [
      {
        "title": "Assets",
        "items": [
          "Adding an asset now suggests matching products for the entered serial number",
          "Finding the right product when adding an asset is now easier with the improved product browser"
        ]
      },
      {
        "title": "Installed Base",
        "items": [
          "New detail view for installed base nodes with the most important information at a glance",
          "Risk assessment reports can now be generated for installed base nodes and discussed with the One AI assistant"
        ]
      },
      {
        "title": "Tables & dashboard",
        "items": [
          "The VSD Candidate widget now also includes assets rated \"Poor\"",
          "New \"Sensor Value out of Range\" dashboard widget; clicking it opens the filtered asset list",
          "The asset list offers new optional columns showing when sensor values were last missing or out of range"
        ]
      }
    ]
  },
  {
    "version": "1.0.1",
    "date": "2026-08-07",
    "groups": [
      {
        "title": "General",
        "items": [
          "Errors now show a plain message instead of confusing technical details"
        ]
      },
      {
        "title": "Assets",
        "items": [
          "Clearer guidance for entering the manufacturer website when adding an asset"
        ]
      },
      {
        "title": "Tables & dashboard",
        "items": [
          "Asset and system lists offer a new optional Location column; hovering shows the full installed base path"
        ]
      }
    ]
  },
  {
    "version": "1.0.0",
    "date": "2026-08-06",
    "groups": [
      {
        "title": "General",
        "items": [
          "Release for Germany and United Kingdom"
        ]
      }
    ]
  },
  {
    "version": "0.3.2",
    "date": "2026-08-03",
    "groups": [
      {
        "title": "General",
        "items": [
          "The About page (version & changelog) moved from Configurations to the Profile section; old links are redirected"
        ]
      },
      {
        "title": "Customer Management",
        "items": [
          "Added CSV export functions for users and companies"
        ]
      },
      {
        "title": "Installed Base",
        "items": [
          "When moving an asset, the removal and installation details now stay consistent while editing: changing the removal date recalculates the running time, and the pump age at the new position follows automatically (own entries always win)",
          "The product catalog in the Add Asset dialog now only shows products that can actually be registered as assets"
        ]
      },
      {
        "title": "Tables & dashboard",
        "items": [
          "A welcome banner on the dashboard introduces the new platform and links to the changelog; it can be removed and re-added like any widget",
          "The About page now starts with a welcome section describing what's new",
          "The attribute option values list now fits the screen and scrolls inside the table",
          "Fixed the \"+N\" counter in the parent option values column stretching over the text; it is now a small tag after the value",
          "Tables no longer show a broken row count while loading; a placeholder appears until the count is ready"
        ]
      }
    ]
  },
  {
    "version": "0.3.1",
    "date": "2026-07-30",
    "groups": [
      {
        "title": "Installed Base",
        "items": [
          "Creating a pressure line now suggests common titles"
        ]
      },
      {
        "title": "IoT / systems",
        "items": [
          "Assets that are part of an IoT system can no longer get their own IoT connection — the setup page now explains which system the asset belongs to",
          "Switched-off systems now show \"System is turned off\" instead of \"Asset is turned off\""
        ]
      }
    ]
  },
  {
    "version": "0.3.0",
    "date": "2026-07-29",
    "groups": [
      {
        "title": "General",
        "items": [
          "Administrators can now publish system announcements — for example maintenance notices — that appear for all users at the top of the app until dismissed"
        ]
      },
      {
        "title": "Installed Base",
        "items": [
          "Assets and imports can now be found by their address — \"Address\" is available in the search options and searched by default",
          "Access group administration has moved to the Customer Management (CRM) app; assigning a node to an access group directly from the installed base tree still works as before",
          "Assigning a node to an access group from the tree now uses the new access group administration permission instead of the old one"
        ]
      },
      {
        "title": "IoT / systems",
        "items": [
          "Firmware versions of IoT devices are now shown correctly in lists, exports and dashboards",
          "IoT statuses are now named and coloured consistently everywhere, e.g. \"Never Connected\"",
          "The IoT status \"Off\" is now called \"Asset is turned off\", so it is clear what is switched off",
          "Never connected and error states now show an icon in the dashboard header",
          "The installed base now guides you on what to add next (IBM-863)"
        ]
      }
    ]
  },
  {
    "version": "0.2.4",
    "date": "2026-07-27",
    "groups": [
      {
        "title": "Installed Base",
        "items": [
          "Systems in the installed base list now show their IoT status and signal strength, like assets (IBM-910)",
          "After deleting a node, the deleted node's parent now stays selected instead of the view jumping one level up",
          "When deleting a node without its sub-nodes, the node being deleted can no longer be chosen as the sub-nodes' new location — it is shown greyed out and its subtree can't be opened in the picker"
        ]
      }
    ]
  },
  {
    "version": "0.2.3",
    "date": "2026-07-24",
    "groups": [
      {
        "title": "IoT / systems",
        "items": [
          "Connecting IoT assets and systems is temporarily limited to companies in Germany and the United Kingdom; other regions see a short explanation instead of the connect form",
          "System types are now numbered, e.g. \"2: Group of pumps with system data\"",
          "Choosing a system type when connecting is clearer: one option per row with image and type number",
          "IoT assets and systems get a new \"Service\" page next to Maintenance",
          "After an IoT contract expires, condition monitoring menu entries are shown locked with an explanation instead of disappearing, and the pages themselves are no longer accessible (admins keep access)",
          "The system dashboard header now appears for all system types, with the external monitoring view shown below it",
          "Connected systems now show their firmware versions in the dashboard header",
          "Systems with a visualization link get a new menu entry that opens it in a new tab",
          "The asset dashboard now shows the firmware versions of connected devices (IBM-879)",
          "Asset specifications now include an \"IoT Configuration\" section with IMEI, oil, operating frequency and contract type (IBM-879)"
        ]
      }
    ]
  },
  {
    "version": "0.2.2",
    "date": "2026-07-21",
    "groups": [
      {
        "title": "Assets",
        "items": [
          "Asset and system dashboards have a fresh look: a large header card highlights the IoT connection (or runtime) at a glance, together with customer details, quick actions, files, and sub-assets (IBM-823)",
          "The new dashboards automatically switch to a space-saving layout in narrow windows (IBM-823)",
          "While a dashboard loads, each card now shows a calm placeholder in its final shape instead of spinners, and content appears only once it is correct — no more banners or statuses flashing and changing during loading (IBM-823)",
          "Dashboards open faster: key information is fetched in fewer requests, revisiting a dashboard shows it instantly, and only the slower network details fill in a moment later (IBM-823)",
          "Improved workflow when adding an asset (IBM-865)",
          "When adding an asset, the product catalog can now be browsed by category, with search across all levels",
          "The asset list can now show and export IoT details such as firmware, SIM and network information (IBM-721)",
          "Exports with IoT data warn about the longer duration and show progress with estimated remaining time (IBM-721)"
        ]
      },
      {
        "title": "Installed Base",
        "items": [
          "Nodes can now be moved to a different place within the same company — including all their children and assets — via the new \"Move\" entry in the column menu and right-click menu, or \"Move asset\" on the asset dashboard (IBM-812)",
          "When moving, a preview shows immediately whether the chosen destination is allowed and which removal or installation details are needed; moves across companies, into an asset, or into the node's own subtree are blocked with a clear explanation (IBM-812)",
          "The installed base can now be navigated with the keyboard: arrow keys move through the list and between columns, and Enter opens the selected entry",
          "Systems now have limits on how many pressure lines and assets they can contain, based on what their IoT device supports — once a limit is reached, adding more is disabled with a short explanation (IBM-462)"
        ]
      },
      {
        "title": "IoT / systems",
        "items": [
          "Existing IoT connections can now be edited via \"Edit connection\" on the asset dashboard, with all current values prefilled (IBM-818)",
          "When editing a connection, service data already recorded by the device is shown read-only (IBM-818)",
          "The gateway IMEI is now required while \"Connected to Gateway\" is checked, and cleared when unchecked (IBM-818)",
          "The connect-device page now explains why a connection isn't possible — product not IoT-ready, missing data, or a loading problem — instead of showing a broken form (IBM-848)",
          "The connect wizard now checks service data: no future dates, and running hours must match the entered dates (IBM-888)",
          "Systems without PLC-based monitoring now get the new dashboard with pressure line readings instead of the external monitoring view (IBM-823)",
          "When connecting a system, types that don't fit the system's current size can no longer be selected, and a hint explains why (IBM-462)",
          "The system dashboard now shows how much of the asset and pressure line limit is used, e.g. \"3 / 30 assets\" (IBM-462)"
        ]
      },
      {
        "title": "Service reminders & notifications",
        "items": [
          "You can now subscribe to monthly IoT reports for a company (IBM-872)",
          "Clicking a report notification downloads the report directly (IBM-872)"
        ]
      }
    ]
  },
  {
    "version": "0.2.1",
    "date": "2026-07-03",
    "groups": [
      {
        "title": "About & changelog",
        "items": [
          "The version history no longer shows an empty \"Unreleased\" section once all changes have been released",
          "Released versions in the version history can now be collapsed and expanded for a quicker overview"
        ]
      },
      {
        "title": "Installed Base",
        "items": [
          "Node dialog titles (create, edit, delete, and similar) now stay on a single line, shortening very long node names with \"…\" so the header no longer wraps"
        ]
      },
      {
        "title": "Events",
        "items": [
          "The new \"On-site Intervention\" event type now shows its name and icon everywhere events appear, in English and German"
        ]
      },
      {
        "title": "Files, previews & gallery",
        "items": [
          "Asset images now show the full picture scaled to fit, instead of being cropped to fill the frame"
        ]
      },
      {
        "title": "Forms & inputs",
        "items": [
          "Installed base node forms now show when a field's value is inherited from a parent node (IBM-699)"
        ]
      },
      {
        "title": "IoT / systems",
        "items": [
          "The connect-system dialog now shows a \"Connect IoT system\" title"
        ]
      }
    ]
  },
  {
    "version": "0.2.0",
    "date": "2026-06-25",
    "groups": [
      {
        "title": "About & changelog",
        "items": [
          "New \"About\" page under Configurations showing the current app version and a list of recent changes"
        ]
      },
      {
        "title": "Installed Base",
        "items": [
          "Path-based routing (selected path as sub-routes) with persistent search & filters (IBM-561)",
          "Node type selection redesign: recommended types, location breadcrumb, auto-expand (IBM-719)",
          "Duplicate nodes wizard with improved feedback (IBM-717)",
          "Breadcrumbs incl. edit-node modal + truncation for long paths (IBM-810)",
          "Restyled node subtitles (IBM-698) and empty column view",
          "No-access state now full content size, no root column (IBM-714)",
          "Load install TDAs after selecting target node (IBM-779)",
          "Auto-paginate/scroll fix"
        ]
      },
      {
        "title": "Assets",
        "items": [
          "Clickable nameplates → navigate to detail view (IBM-778)",
          "RMA link button (IBM-785)",
          "Long breadcrumb trails on asset and system detail pages now stay on one line, collapsing the middle into a clickable \"…\" you can expand (IBM-810)"
        ]
      },
      {
        "title": "Files, previews & gallery",
        "items": [
          "Light gallery + image previews: tile view & list view, dark/light mode toggle (IBM-559)",
          "Server-side resized file thumbnails + width-capped lightbox previews; square-filled grid tiles",
          "Event file upload moved to installed base node (IBM-598)"
        ]
      },
      {
        "title": "Events",
        "items": [
          "Event editing: update events, limited to lifecycle events (IBM-774)",
          "Remove event directly from installed base (IBM-700)",
          "IoT system update offer after path-changing asset events (IBM-784)"
        ]
      },
      {
        "title": "Service reminders & notifications",
        "items": [
          "Service reminders (IBM-758): full CRUD, card audit info, due-date validation/plausibility checks, status badge styling",
          "Notification subscriptions reworked; subscription modal + due-date input; \"mute until\" relabeling"
        ]
      },
      {
        "title": "IoT / systems",
        "items": [
          "Differentiate non-IoT vs non-PLC systems (IBM-732)",
          "Show NEVER_CONNECTED IoT assets in overviews (IBM-792)",
          "Show IoT data to admins for expired contracts (IBM-755)",
          "IoT system edit iframe (IBM-817)"
        ]
      },
      {
        "title": "Forms & inputs",
        "items": [
          "Number-with-unit (Days/Hours) input for TDA form & required indices (IBM-781)",
          "Backend-driven date presets via optionValues, removed DueDateInput (IBM-775)",
          "Date inputType via shared components (IBM-789)",
          "Bool-select validation \"0\"/\"1\" (IBM-770)"
        ]
      },
      {
        "title": "Tables & dashboard",
        "items": [
          "CSV export reworked: export all data or visible columns only; separate \"manage columns\" button (IBM-635)",
          "Dashboard responsive layout, personal space first (IBM-630)"
        ]
      },
      {
        "title": "Branding",
        "items": [
          "ARGOS branding: palette, hide IoT for semiconductor clients, OTTO/ARGOS differentiation (IBM-747)"
        ]
      },
      {
        "title": "Tests & chores",
        "items": [
          "e2e test fixes (no-access IB, first-column header auto-skip-root); GraphQL schema alignment"
        ]
      }
    ]
  }
];
